@if (batchProgress.isBatching) {
  <section class="step-progress" role="status">
    <progress-circle [progress]="batchProgress.percentage" label="Import progress" />
    <p class="step-progress__title">
      @if (batchProgress.totalBatches > 0) {
        Sending batch {{ batchProgress.currentBatch }} of {{ batchProgress.totalBatches }}
      } @else {
        Getting the upload ready
      }
    </p>
    <p class="step-progress__hint">This file is large, so it goes in batches. Keep this page open.</p>
  </section>
} @else {
  <section class="map">
    @if (!headers.length) {
      <div class="step-notice is-error" role="alert">
        <span class="bk-sym" aria-hidden="true">error</span>
        <p class="step-notice__text">The file is no longer loaded, so there are no columns to match. Go back and choose it again.</p>
        <div class="step-notice__actions">
          <button type="button" class="bk-btn bk-btn--ghost" (click)="goToPrevious()">Choose the file again</button>
        </div>
      </div>
    }

    @if (showAutoMappingPrompt) {
      <div class="map__notice" role="status">
        <span class="bk-sym" aria-hidden="true">auto_awesome</span>
        <p class="map__notice-text">
          @if (getUsingTemplate) {
            This is the Black Konnect template, so the columns are already matched. Check them, then continue.
          } @else {
            Matched {{ autoMatched.length }} {{ autoMatched.length === 1 ? 'column' : 'columns' }} from their names. Check
            them before you continue.
          }
        </p>
        <button type="button" class="bk-more" (click)="undoAutoMatch()">Undo</button>
        <button type="button" class="bk-icon-btn" aria-label="Dismiss" (click)="closeAutoMappingPrompt()">
          <span class="bk-sym" aria-hidden="true">close</span>
        </button>
      </div>
    }

    <form class="bk-panel map__panel" [formGroup]="mapperForm" (ngSubmit)="goToReview()" novalidate>
      <div class="map__head" aria-hidden="true">
        <span>Contact field</span>
        <span>Column in your file</span>
        <span class="map__col-sample">Sample from your file</span>
      </div>

      @for (field of fields; track field.key) {
        <div class="map__row" [class.is-missing]="isMissing(field)">
          <label class="map__field" [for]="'map-' + field.key">
            {{ field.label }}
            @if (field.required) {
              <span class="map__req">Required</span>
            }
          </label>

          <div class="map__select">
            <select
              class="bk-field__input"
              [id]="'map-' + field.key"
              [formControlName]="field.key"
              [attr.aria-invalid]="isMissing(field) ? 'true' : null"
              [attr.aria-describedby]="'map-' + field.key + '-note'"
            >
              <option value="">{{ field.required ? 'Choose a column' : 'Don’t import' }}</option>
              @for (header of headers; track $index) {
                <option [value]="header">{{ header || 'Column ' + ($index + 1) }}</option>
              }
            </select>
            <p class="map__note" [id]="'map-' + field.key + '-note'">
              @if (isMissing(field)) {
                <span class="map__error">
                  <span class="bk-sym" aria-hidden="true">error</span>
                  {{ field.hint }}
                </span>
              } @else if (sharedWith(field.key)) {
                Also used for {{ sharedWith(field.key) }}
              }
            </p>
          </div>

          <p class="map__sample">
            <!-- The column headers are hidden from screen readers; this names the value. -->
            <span class="map__sample-label">Sample: </span>
            @if (sampleFor(field.key)) {
              <span class="map__sample-value">{{ sampleFor(field.key) }}</span>
            } @else if (mapperForm.get(field.key)?.value) {
              <span class="map__faint">Empty in the first rows</span>
            } @else {
              <span class="map__faint">—</span>
            }
          </p>
        </div>
      }
    </form>

    <p class="map__meta">
      {{ mappedCount }} of {{ fields.length }} fields matched · {{ formatCount(rowCount) }}
      {{ rowCount === 1 ? 'row' : 'rows' }} in the file. Columns you do not match are left out.
    </p>
  </section>

  <stepper-controls
    class="sticky bottom-0"
    leftButtonLabel="Back"
    rightButtonLabel="Check rows"
    (leftButtonClick)="goToPrevious()"
    (rightButtonClick)="goToReview()"
    [loading]="csvService.isLoading"
  />
}
